import { render, staticRenderFns } from "./LiveVideoPlus.vue?vue&type=template&id=5a5d2899"
import script from "./LiveVideoPlus.vue?vue&type=script&lang=js"
export * from "./LiveVideoPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports